import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";

export function TopupHistorySkeleton() {
  return (
    <div className="mt-2">
      {/* Mobile */}
      <div className="flex flex-col gap-2 md:hidden">
        {Array.from({ length: 5 }).map((_, index) => (
          <div
            key={index}
            className="rounded-2xl bg-card p-4 shadow-xl"
          >
            <div className="flex items-center justify-between gap-2">
              <Skeleton className="h-4 w-28" />
              <Skeleton className="h-6 w-20 rounded-lg" />
            </div>

            <Skeleton className="mt-2 h-px w-full" />

            <div className="mt-4 flex items-center justify-between">
              <div className="flex items-center gap-2">
                <Skeleton className="h-4 w-20" />
                <Skeleton className="h-5 w-px" />
                <Skeleton className="h-4 w-16" />
              </div>

              <Skeleton className="size-6 rounded-full" />
            </div>

            <Skeleton className="mt-4 h-3 w-32" />
          </div>
        ))}
      </div>

      {/* Desktop */}
      <div className="hidden md:block">
        {/* Header */}
        <div className="grid grid-cols-12 items-center gap-4 rounded-t-2xl bg-primary px-6 py-3">
          <div className="text-sm font-medium text-card">
            Top-up no.
          </div>

          <div className="col-span-2 text-center text-sm font-medium text-card">
            Issued E.Invoice
          </div>

          <div className="col-span-4 text-sm font-medium text-card">
            Route
          </div>

          <div className="text-sm font-medium text-card">
            Price
          </div>

          <div className="text-center text-sm font-medium text-card">
            Pax.
          </div>

          <div className="col-span-2 text-sm font-medium text-card">
            Date. Time
          </div>

          <div className="text-right text-sm font-medium text-card">
            Action
          </div>
        </div>

        {/* Rows */}
        <div className="overflow-hidden rounded-b-2xl bg-card shadow-xl md:px-6">
          {Array.from({ length: 5 }).map((_, index) => (
            <div
              key={index}
              className={cn(
                "grid grid-cols-12 items-center gap-4 py-2",
                index > 0 && "border-t border-border",
              )}
            >
              {/* Top-up no. */}
              <Skeleton className="h-4 w-28" />

              {/* E.Invoice */}
              <div className="col-span-2 flex justify-center">
                <Skeleton className="h-6 w-20 rounded-lg" />
              </div>

              {/* Route */}
              <Skeleton className="col-span-4 h-4 w-40" />

              {/* Price */}
              <Skeleton className="h-4 w-20" />

              {/* Pax */}
              <div className="flex justify-center">
                <Skeleton className="h-4 w-12" />
              </div>

              {/* Date */}
              <Skeleton className="col-span-2 h-4 w-32" />

              {/* Action */}
              <div className="flex justify-end">
                <Skeleton className="size-8 rounded-lg" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}